import { googleMeasurementConsent } from './googleMeasurementConsent.js';

// Preserve the edge-loaded GTM queue and set consent before config or events.
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
window.gtag('consent', 'default', {
  ...googleMeasurementConsent(),
  functionality_storage: 'granted',
  security_storage: 'granted',
});
window.gtag('set', 'ads_data_redaction', true);
window.gtag('set', 'url_passthrough', false);
window.prerenderReady = false;
